// @flow
import React from "react";
import DetailsView from "buba-components/src/views/Details";
import { withRouter } from "react-router-dom";
import { customerInquiryTabs } from "../../data/navLinks";
import paths from "../../data/paths";
import { getInquiryFromBankOffer } from "../../api/actions";

type CustomerInquiryDetailsProps = {
  match: {
    params: {
      id: number
    }
  }
};

const CustomerInquiryDetails = ({ match }: CustomerInquiryDetailsProps) => {
  return (
    <DetailsView
      match={match}
      getTabs={() => customerInquiryTabs}
      backPath={() => paths.customerInquiriesList}
      getInquiry={getInquiryFromBankOffer}
      site="bank"
    />
  );
};

export default withRouter(CustomerInquiryDetails);
